import React from 'react';
import PropTypes from 'prop-types';

const ServiceAddressForm = ({
  serviceAddress,
  onEditClick,
}) => {
  const formatAddress = (address) => {
    if (!address) return null;

    const line1 = address.streetLine1 ? address.streetLine1 : '';
    const line2 = address.streetLine2 ? address.streetLine2 : '';
    const city = address.locality ? address.locality : '';
    const state = address.state ? address.state : '';
    const zip = address.postalCode ? address.postalCode : '';
    const country = address.country ? address.country : '';

    return `${line1}${line2 ? `, ${line2}` : ''}
${city}, ${state} ${zip}
${country}`;
  };

  return (
    <div className="row align-items-start">
      <div className="col-sm-3 col-md-2">
        <strong>Service Address</strong>
      </div>
      <div className="col-sm-6 col-md-7">
        {serviceAddress ? (
          <div style={{ whiteSpace: 'pre-line' }}>
            {formatAddress(serviceAddress)}
          </div>
        ) : (
          <span className="text-muted font-italic">Address required</span>
        )}
      </div>
      <div className="col-sm-3 col-md-3 text-end">
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={onEditClick}
        >
          Edit
        </button>
      </div>
    </div>
  );
};

ServiceAddressForm.defaultProps = {
  serviceAddress: null,
};

ServiceAddressForm.propTypes = {
  serviceAddress: PropTypes.shape({
    streetLine1: PropTypes.string,
    streetLine2: PropTypes.string,
    locality: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }),
  onEditClick: PropTypes.func.isRequired,
};

export default ServiceAddressForm;
